import core from '../modules/core';
import utils from '@/utils/utils'

export default {
  login(parameters) {
    return core.call({
      url: '/api/v1/auth/issueAuthToken',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Basic ' + utils.nativeCom.getUserAgentValue("client") ,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    });  
  },
}